import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Login } from "src/Modules/Login";
import { Layout } from "src/Common";
import { RouteFallback } from "src/Common/components/RouteFallback/RouteFallback";
import { AUTH_DISABLED } from "./Providers";
import { useAuth } from "src/Common/context/AuthContext";

// Imported from the concrete module file, never from the `src/Modules`
// barrel: the barrel re-exports every module, so one static edge through it
// would pull all four back into the entry chunk.
const Arbitrage = lazy(() =>
  import("src/Modules/Arbitrage/Arbitrage").then((m) => ({
    default: m.Arbitrage,
  }))
);
const PredictionsModule = lazy(() =>
  import("src/Modules/Predictions/Predictions").then((m) => ({
    default: m.PredictionsModule,
  }))
);
const ConfigEditor = lazy(() =>
  import("src/Modules/ConfigEditor/ConfigEditor").then((m) => ({
    default: m.ConfigEditor,
  }))
);
const AssetCatalog = lazy(() =>
  import("src/Modules/AssetCatalog/AssetCatalog").then((m) => ({
    default: m.AssetCatalog,
  }))
);

function getDefaultRoute(): string {
  const storedMode = localStorage.getItem("app_mode");
  if (storedMode === "predictions") return "/predictions/opportunities";
  return "/arbitrage";
}

const AuthenticatedApp = () => (
  <BrowserRouter>
    <Layout>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="arbitrage/*" element={<Arbitrage />} />
          <Route path="predictions/*" element={<PredictionsModule />} />
          <Route path="config-editor/*" element={<ConfigEditor />} />
          <Route path="assets" element={<AssetCatalog />} />
          {/* Redirects from old paths */}
          <Route
            path="prediction-mapper"
            element={<Navigate replace to="/predictions/mapper" />}
          />
          <Route
            path="arbitrage/predictions"
            element={<Navigate replace to="/predictions/opportunities" />}
          />
          <Route
            path="arbitrage/predictions/*"
            element={<Navigate replace to="/predictions/opportunities" />}
          />
          <Route
            path="arbitrage/predictions-status"
            element={<Navigate replace to="/predictions/status" />}
          />
          <Route
            path="/"
            element={<Navigate replace to={getDefaultRoute()} />}
          />
        </Routes>
      </Suspense>
    </Layout>
  </BrowserRouter>
);

export const AppRouter = () => {
  const { isAuthenticated } = useAuth();

  if (AUTH_DISABLED || isAuthenticated) {
    return <AuthenticatedApp />;
  }

  return <Login />;
};
